import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

import * as firebase from '@/services/firebase'
import * as jwt from '@/services/jwt'

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    register: firebase.register,
    currentAccount: firebase.currentAccount,
    logout: firebase.logout,
  },
  jwt: {
    login: jwt.loginNew,
    loginverificator: jwt.loginverificator,
    register: jwt.register,
    currentAccount: jwt.currentAccount,
    logout: jwt.logout,
  },
}

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    id: '',
    name: '',
    role: '',
    email: '',
    avatar: '',
    admin: false,
    authorized: process.env.VUE_APP_AUTHENTICATED || false, // false is default value
    loading: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    LOGIN({ commit, dispatch, rootState }, { payload }) {
      const { email, password } = payload
      commit('SET_STATE', {
        loading: true,
      })

      const login = mapAuthProviders[rootState.settings.authProvider].login
      const role = 'dashboard'
      login(email, password, role).then((success) => {
        if (success) {
          console.log(success)
          let admin = false
          if (success.role === 'admin') {
            admin = true
          }
          commit('SET_STATE', {
            id: success.id,
            name: '',
            email: success.email,
            avatar: '',
            role: success.role,
            authorized: true,
            admin: admin,
          })
          window.localStorage.setItem('id', success.id)
          window.localStorage.setItem('email', success.email)
          window.localStorage.setItem('role', success.role)
          window.localStorage.setItem('authorized', true)
          window.localStorage.setItem('admin', admin)
          // router.push('/dashboard')
          // dispatch('LOAD_CURRENT_ACCOUNT')
          // Vue.prototype.$notification.success({
          //   message: 'Logged In',
          //   description: 'You have successfully logged in to Air UI Vue Admin Template!',
          // })
        }
        if (!success) {
          commit('SET_STATE', {
            loading: false,
          })
        }
      })
    },
    LOGINVERIFICATOR({ commit, dispatch, rootState }, { payload }) {
      const { email, password } = payload
      commit('SET_STATE', {
        loading: true,
      })

      const login =
        mapAuthProviders[rootState.settings.authProvider].loginverificator
      login(email, password).then((success) => {
        if (success) {
          console.log(success)
          commit('SET_STATE', {
            id: success.id,
            name: '',
            email: success.email,
            avatar: '',
            role: 'Verificator',
            authorized: true,
            admin: false,
          })
          window.localStorage.setItem('id', success.id)
          window.localStorage.setItem('email', success.email)
          window.localStorage.setItem('role', success.role)
          window.localStorage.setItem('authorized', true)
          window.localStorage.setItem('admin', false)
          // router.push('/dashboard')
          // dispatch('LOAD_CURRENT_ACCOUNT')
          // Vue.prototype.$notification.success({
          //   message: 'Logged In',
          //   description: 'You have successfully logged in to Air UI Vue Admin Template!',
          // })
        }
        if (!success) {
          commit('SET_STATE', {
            loading: false,
          })
        }
      })
    },
    REGISTER({ commit, dispatch, rootState }, { payload }) {
      const { email, password, name } = payload
      commit('SET_STATE', {
        loading: true,
      })

      const register =
        mapAuthProviders[rootState.settings.authProvider].register
      register(email, password, name).then((success) => {
        if (success) {
          dispatch('LOAD_CURRENT_ACCOUNT')
          Vue.prototype.$notification.success({
            message: 'Succesful Registered',
            description: 'You have successfully registered!',
          })
        }
        if (!success) {
          commit('SET_STATE', {
            loading: false,
          })
        }
      })
    },
    LOAD_CURRENT_ACCOUNT({ commit, rootState }) {
      commit('SET_STATE', {
        loading: true,
      })
      const id = window.localStorage.getItem('id')
      const email = window.localStorage.getItem('email')
      const role = window.localStorage.getItem('role')
      const authorized = window.localStorage.getItem('authorized')
      const admin = window.localStorage.getItem('admin')
      if (authorized && id) {
        commit('SET_STATE', {
          id: id,
          name: '',
          email: email,
          avatar: '',
          role: role,
          authorized: authorized,
          admin: admin,
        })
      }
      commit('SET_STATE', {
        loading: false,
      })
    },
    LOGOUT({ commit, rootState }) {
      const logout = mapAuthProviders[rootState.settings.authProvider].logout
      window.localStorage.clear()
      logout().then(() => {
        commit('SET_STATE', {
          id: '',
          name: '',
          role: '',
          email: '',
          avatar: '',
          authorized: false,
          loading: false,
        })
        router.push('/auth/login')
      })
    },
  },
  getters: {
    user: (state) => state,
  },
}
